import customModal from "../customModal/customModal.vue";

export default{
    name: "riskListPopup",
    components: {
        customModal,
    },
    props:{
        data: Object,
        title: Array,
    },
    data(){
        return{
            baseUrl: process.env.VUE_APP_Service_URL,
            headerValues: {},
            idToken: "",
        }
    },
    mounted(){
    console.log("RiskListPopup mounted");
    },
    methods: {
        closeRiskModal() {
            this.$emit("closepopup");
        },
    }
}